import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const redingtonBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Redington Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Redington Beach, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_redington_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Redington Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Redington Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we take care of the tree work that keeps 
     properties safe in <strong>Redington Beach</strong>. This quiet Gulf front 
     community attracts homeowners who take pride in their properties and that means 
     keeping trees healthy, well trimmed, and free of storm hazards. Whether it's a 
     palm leaning over your lanai or an oak with a split canopy threatening your roof, 
     our team handles it with precision and professionalism.`,

    `We specialize in <strong>dangerous tree situations on barrier island properties</strong> 
     salt damaged trunks, wind stressed canopies, overhanging limbs near structures 
     and seawalls, and post storm cleanup that gets your property back in order fast. 
     We assess every job thoroughly and execute safely.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, affordable tree care 
     throughout <strong>Redington Beach</strong> and the full stretch of 
     <strong>South Pinellas Gulf beaches</strong> keeping your coastal property 
     protected and your landscape in great condition all year long.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Redington Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_RedingtonBeach = () => <LocationPage config={redingtonBeachConfig} />;
export default Services_RedingtonBeach;
